/* eslint-disable @angular-eslint/component-selector */
import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
} from '@angular/core';
import { MatMenu } from '@angular/material/menu';
import { Subject } from 'rxjs';
import { ContextMenuContainerComponent } from './context-menu-container.component';

import { ContextMenuComponent } from './context-menu.component';

@Component({
    selector: '[luiContextMenuButtonFor]',
    templateUrl: './context-menu-button.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ContextMenuButtonComponent {
  @HostBinding('class') className = 'lui-context-menu-button';

  @Input() luiContextMenuButtonFor!: ContextMenuComponent | undefined;

  @Input() get matMenuTriggerFor(): MatMenu {
    return this._matMenu;
  }
  set matMenuTriggerFor(menu: MatMenu) {
    if (menu instanceof MatMenu) {
      this._matMenu = menu;
      this._matMenu.panelClass = 'context-menu-mat-menu';
    }
  }
  _matMenu!: MatMenu;

  @Input() refId!: string | number;

  constructor(private _container: ContextMenuContainerComponent) {}

  _destroy = new Subject<void>();

  open() {
    this._container.open();
  }

  close() {
    this._container.close();
  }

  toggle(opened: boolean) {
    this._container.toggle(opened);
  }
}
